import React from "react";
import { Formik } from "formik";
import { MimaButton, MimaInput, MimaText, Modal } from "../../../components";

const EditAd = ({ loading, onSubmit, closeModal, validationSchema, item }) => {
  return (
    <Modal closeModal={closeModal}>
      <MimaText variant="subtitleBold" align="center" mb="7">
        Edit Ad
      </MimaText>
      <Formik
        initialValues={{
          rate: item.rate || 0,
          availableAmount: item.availableAmount || 0,
          minPerSale: item.minPerSale || 0,
        }}
        onSubmit={onSubmit}
        validationSchema={validationSchema}
      >
        {({
          handleChange,
          handleBlur,
          handleSubmit,
          setFieldValue,
          values,
          errors,
          touched,
        }) => (
          <div>
            <div className="modal__beside">
              <MimaInput
                labelTitle="Rate"
                variant="form2"
                name="rate"
                type="number"
                value={values.rate}
                placeholder="Enter Rate"
                onChange={handleChange}
                onBlur={handleBlur}
                error={errors.rate}
                touched={touched.rate}
                width={18}
              />
              <MimaInput
                labelTitle="Available Amount"
                variant="form2"
                name="availableAmount"
                type="number"
                value={values.availableAmount}
                placeholder="Enter available amount"
                onChange={handleChange}
                onBlur={handleBlur}
                error={errors.availableAmount}
                touched={touched.availableAmount}
                width={18}
              />
            </div>

            <MimaInput
              labelTitle="Min per sale"
              variant="form2"
              name="minPerSale"
              type="number"
              value={values.minPerSale}
              placeholder="Enter min per sale"
              onChange={handleChange}
              onBlur={handleBlur}
              error={errors.minPerSale}
              touched={touched.minPerSale}
            />

            <MimaButton
              title="Edit"
              width={38}
              // buttonColor="var(--color-dark)"
              onClick={handleSubmit}
              loading={loading}
            />
          </div>
        )}
      </Formik>
    </Modal>
  );
};
export default EditAd;
